(function(){
     'use strict';

     angular
        .module('app')
        .factory('ContentService', ContentService);

    ContentService.$inject = ['$http'];

    function ContentService($http){


        var service= {
            getCampos: getCampos,
            saveCampos:saveCampos,
            getListado:getListado,
            borrarContenido:borrarContenido,
            getContenidoCampo:getContenidoCampo,
            getCamposModel:getCamposModel,
            getValueCamposModel:getValueCamposModel,
            valueReferencedModel : {}
        };

        return service;

        function getCampos(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var json = $('.inputsAll').serializeObject();

            var data = $.param({
                json : json,
                id:vm.content_id,
                lang_id:vm.lang_id,
                lang_id_copy:vm.lang_id_copy,
                type: vm.type,
                searchModel:vm.modelSearch,
                paramfield : (typeof(vm.params)!='undefined' ? vm.params.field : '')
            });
            $http.post('/backend/altcrm/content/getcampos', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getContenidoCampo(type,value,campo,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var json = $('.inputsAll').serializeObject();

            var data = $.param({
                type : type,
                value:value,
                campo:campo
            });
            $http.post('/backend/altcrm/content/getcontenidocampo', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function borrarContenido(id,type,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                id:id,
                type:type
            });
            $http.post('/backend/altcrm/content/borrarcontenido', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        function getListado(node_type,pagina,tipo_cuadro,cuadro_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                tipo_cuadro:tipo_cuadro,
                type:node_type,
                cuadro_id:cuadro_id,
                pagina:pagina
            });

            $http.post('/backend/altcrm/content/getlistado', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function saveCampos(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var json = $('.inputsAll').serializeObject();
            if(vm.duplicar==1){
                vm.content_id = "";
            }
            var data = $.param({
                type: vm.type,
                id:vm.content_id,
                lang_id:vm.lang_id,
                campos:vm.campos
                
            });
            $http.post('/backend/altcrm/content/savecampos', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getCamposModel(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                params: vm.params,
                type: vm.params.node_type
            });
            $http.post('/backend/altcrm/content/getcamposrelmodel', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getValueCamposModel(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                campos: vm.campos,
                type: vm.params.node_type
            });
            $http.post('/backend/altcrm/content/getvalorescamposrelmodel', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        
    }
})();